/**
 * meto8 侧公共根地址（登录、会话历史、会员充值等）。
 * npm run serve → 开发环境；npm run build → 生产环境。
 * 可通过环境变量 VUE_APP_METO8_API_BASE 覆盖。
 */
export const METO8_API_BASE =
  process.env.VUE_APP_METO8_API_BASE ||
  (process.env.NODE_ENV === 'development'
    ? 'http://171.212.102.67:8100'
    : 'https://www.meto8.top:8000')
